import React, { useEffect, useState, useCallback } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

import { db } from "../../../firebase";
import { doc, getDoc, collection, getDocs } from "firebase/firestore";
import { getStorage, ref, getDownloadURL, listAll, deleteObject, uploadBytes } from "firebase/storage";

import SEO from '../../SEO';
import Popup from "../../mobile/Popup";
import MusicardPopup from "../../Musicard/mobile/MusicardPopup";
import Loading from "../../Loading";
import MyPageMenu from './MyPageMenu';
import Share from "../../Musicard/mobile/Share";

import html2pdf from 'html2pdf.js';

import { useUser } from '../../../store/UserProvider';

import styleClasses from '../css/mobile/MyPage.module.scss';


function Portfolio() {
    const navigate  = useNavigate();
    const location  = useLocation();

    const { musicardID }        = location.state || {};
    const { user, userLoading } = useUser();

    const [openMenu, setOpenMenu]               = useState(false);

    const [userMobile, setUserMobile]           = useState('');
    const [userAddress, setUserAddress]         = useState('');
    const [userID, setUserID]                   = useState(null);
    const [userQR, setUserQR]                   = useState(null);
    const [userInfo, setUserInfo]               = useState(null);
    const [userPortfolio, setUserPortfolio]     = useState(null);
    const [musicardInfo, setMusicardInfo]       = useState(null);
    const [userLinks, setUserLinks]             = useState(null);
    const [memberID, setMemberID]               = useState(null);
    const [isLoading, setIsLoading]             = useState(false);
    const [downloadLoading, setDownloadLoading] = useState(false);
    const [viewLoading, setViewLoading]         = useState(false);
    const [openPopup, setOpenPopup]             = useState(false);
    const [popupTitle, setPopupTitle]           = useState('');
    const [popupFunction, setPopupFunction]     = useState('');
    const [popupButtonText, setPopupButtonText] = useState('');

    // 추가: 공유 URL state (업로드 후 PDF의 다운로드 URL)
    const [sharedUrl, setSharedUrl] = useState('');
    // Share 창 열기 여부
    const [showShare, setShowShare] = useState(false);

  // 🔹 메뉴 열기
  const toogleMenu = useCallback(
    (event) => {
      const menuIcon = event.target.closest(`.${styleClasses.menuIcon}`);
      const menuBox = event.target.closest(`.${styleClasses.leftContent}`);

      if (openMenu) {
        if (!menuBox) setOpenMenu(false);
      } else {
        if (menuIcon || menuBox) setOpenMenu(true);
      }
    },
    [openMenu, setOpenMenu]
  );

  // 🔹 메뉴 열기 (스크린 전체 이벤트 추가)
  useEffect(() => {
    document.body.addEventListener("click", toogleMenu);

    return () => {
      document.body.removeEventListener("click", toogleMenu);
    };
  }, [toogleMenu]);

    // 레벨에 따른 퍼센티지 매핑
    const levelToPercentage = {
        Beginner: 25,
        Intermediate: 50,
        Advanced: 75,
        Expert: 100,
    };

    // 🔹 모든 정보 조회
    const fetchPortfolio = useCallback(async () => {
        if (userID && musicardID) {
            try {
                // 1. 유저 기본 정보 (users 컬렉션)
                const userRef = doc(db, "users", userID);
                const userSnap = await getDoc(userRef);
                if (userSnap.exists()) {
                    setUserInfo(userSnap.data());
                }
        
                // 2. 뮤지카드 기본 정보 (musicians 컬렉션)
                const musicardRef = doc(db, "musicians", musicardID);
                const musicardSnap = await getDoc(musicardRef);
                if (musicardSnap.exists()) {
                    const musicardData = musicardSnap.data();
        
                    // 소유자 검증: 현재 유저가 뮤지카드 소유자가 아니면 오류 처리
                    if (musicardData.ownerId !== userID) {
                        setOpenPopup(true);
                        setPopupTitle("해당 뮤지카드의 소유자가 아닙니다.");
                        setPopupButtonText("");
                        setPopupFunction("");
                        setIsLoading(false);
                        return;
                    }
                    setMusicardInfo(musicardData);
                } else {
                    throw new Error("뮤지카드 정보를 찾을 수 없습니다.");
                }
        
                // 3. 스타일 정보 (스트리밍 & SNS & QR 코드) - musicians/{musicardID}/style/main
                const styleRef = doc(db, "musicians", musicardID, "style", "main");
                const styleSnap = await getDoc(styleRef);
                if (styleSnap.exists()) {
                    const styleData = styleSnap.data();
                    let newLinks = [];
                    // 스트리밍 링크
                    if (styleData.musicLinks) {
                        Object.entries(styleData.musicLinks).forEach(([key, value]) => {
                            const newKey = key.charAt(0).toUpperCase() + key.slice(1);
                            if (value.trim() !== "") {
                                newLinks.push({ newKey, value });
                            }
                        });
                    }
                    // SNS 링크
                    if (styleData.sns) {
                        Object.entries(styleData.sns).forEach(([key, value]) => {
                            const newKey = key.charAt(0).toUpperCase() + key.slice(1);
                            if (value.trim() !== "") {
                                newLinks.push({ newKey, value });
                            }
                        });
                    }
                    if (styleData.qrimg) {
                        setUserQR(styleData.qrimg);
                    }
                    setUserLinks(newLinks);
                }
        
                // 4. 포지션 & 스킬 (musicians/{musicardID}/positions)
                const positionsSnap = await getDocs(collection(db, "musicians", musicardID, "positions"));
                const positionsData = [];
                for (const posDoc of positionsSnap.docs) {
                    // 각 포지션의 스킬 불러오기
                    const skillsSnap = await getDocs(collection(db, "musicians", musicardID, "positions", posDoc.id, "skills"));
                    let skills = skillsSnap.docs.map(skillDoc => {
                        const s = skillDoc.data();
                        return { name: s.name, level: s.level };
                    });
                    // 알파벳순 정렬
                    skills.sort((a, b) => a.name.localeCompare(b.name));
                    positionsData.push({ id: posDoc.id, skills });
                }
                // (원하는 순서대로 정렬 – 예시: creator, player, engineer)
                const order = ["creator", "player", "engineer"];
                positionsData.sort((a, b) => order.indexOf(a.id) - order.indexOf(b.id));
        
                // 5. 앨범(경력사항) - musicians/{musicardID}/ownAlbums, collaboAlbums, unreleasedAlbums
                const albumTypes = ["ownAlbums", "collaboAlbums", "unreleasedAlbums"];
                let archiveData = [];
                // 각 앨범 컬렉션별로 불러오기
                for (const type of albumTypes) {
                    const albumSnap = await getDocs(collection(db, "musicians", musicardID, type));
                    albumSnap.forEach(docSnap => {
                        const data = docSnap.data();
                        // year 필드가 Timestamp 객체라면 toDate()를 호출하여 Date 객체로 변환, 아니면 new Date()로 처리
                        let year;
                        if (data.year && typeof data.year.toDate === 'function') {
                          year = data.year.toDate();
                        } else {
                          year = new Date(data.year);
                        }
                        archiveData.push({ id: docSnap.id, attribute: type, ...data, year });
                    });
                }
                // 연도 내림차순 정렬 (연도가 string이므로 parseInt 사용)
                archiveData.sort((a, b) => {
                    // unreleasedAlbums인 경우 항상 아래로
                    if (a.attribute === "unreleasedAlbums" && b.attribute !== "unreleasedAlbums") {
                      return 1; // a를 b 뒤로 보냄
                    }
                    if (b.attribute === "unreleasedAlbums" && a.attribute !== "unreleasedAlbums") {
                      return -1; // b를 a 뒤로 보냄
                    }
                    // 둘 다 unreleasedAlbums이거나 둘 다 아닌 경우 연도 내림차순 정렬
                    return new Date(b.year) - new Date(a.year);
                });                  
        
                // 각 앨범의 제목 및 트랙 타이틀 처리
                for (let album of archiveData) {
                    if (album.attribute === "unreleasedAlbums") {
                        album.albumType = "미발매";
                        album.albumTitle = album.title ? album.title.replace(/\[.*?\]/, "").trim() : "";
                    } else if (album.title && album.title.includes("[EP]")) {
                        album.albumType = "EP";
                        album.albumTitle = album.title.replace("[EP]", "").trim();
                    } else if (album.title && album.title.includes("[정규]")) {
                        album.albumType = "정규";
                        album.albumTitle = album.title.replace("[정규]", "").trim();
                    } else if (album.title && album.title.includes("[싱글]")) {
                        album.albumType = "싱글";
                        album.albumTitle = album.title.replace("[싱글]", "").trim();
                    } else if (album.title && album.title.includes("[옴니버스]")) {
                        album.albumType = "옴니버스";
                        album.albumTitle = album.title.replace("[옴니버스]", "").trim();
                    } else if (album.title && album.title.includes("[OST]")) {
                        album.albumType = "OST";
                        album.albumTitle = album.title.replace("[OST]", "").trim();
                    } else {
                        album.albumType = "";
                        album.albumTitle = album.title ? album.title.trim() : "";
                    }

                    // 트랙 정보 (tracks 서브컬렉션)
                    const tracksSnap = await getDocs(collection(db, "musicians", musicardID, album.attribute, album.id, "tracks"));
                    if (!tracksSnap.empty) {
                        const fetchedTracks = tracksSnap.docs.map((doc, index) => ({
                            id: (index + 1).toString().padStart(2, "0"),
                            ...doc.data(),
                        }));
                        album.trackTitle = "";
                        album.trackLink = "";
                        for (const track of fetchedTracks) {
                            const title = track.title?.toUpperCase() ?? "";
                            if (title.includes("[TITLE]")) {
                                album.trackTitle = title.replace("[TITLE] ", "");
                                album.trackLink = track.url;
                            }
                        }
                    }
                }
        
                // 6. 활동사항 - events와 stages 병합 (musicians/{musicardID}/events, musicians/{musicardID}/stages)
                const eventsSnap = await getDocs(collection(db, "musicians", musicardID, "events"));
                const stagesSnap = await getDocs(collection(db, "musicians", musicardID, "stages"));
                let eventsData = eventsSnap.docs.map(doc => ({ id: doc.id, ...doc.data(), type: "event" }));
                let stagesData = stagesSnap.docs.map(doc => ({ id: doc.id, ...doc.data(), type: "stage" }));
                let activitiesData = [...eventsData, ...stagesData];
                // 날짜 내림차순 정렬 (날짜 포맷이 동일하다고 가정)
                activitiesData.sort((a, b) => new Date(b.date) - new Date(a.date));
                // 링크 및 추가 정보 설정 (videoId가 있는 경우 유튜브 링크 생성)
                activitiesData = activitiesData.map(activity => {
                    if (activity.videoId) {
                        activity.link = `https://www.youtube.com/watch?v=${activity.videoId}`;
                    }
                    if (activity.type === "event") {
                        activity.rechannel = activity.host || "";
                    } else if (activity.type === "stage") {
                        activity.rechannel = activity.stage || "";
                    } else {
                        activity.rechannel = "";
                    }
                    return activity;
                });
        
                // 7. 연락처 - musicians/{musicardID}/contact
                const contactsSnap = await getDocs(collection(db, "musicians", musicardID, "contact"));
                const contactsData = contactsSnap.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        
                // 8. 멤버 - musicians/{musicardID}/members
                // const membersData = [];
                // if (memberID) {
                const membersSnap = await getDocs(collection(db, "musicians", musicardID, "members"));
                const membersData = membersSnap.docs.map(doc => ({
                    id: doc.id,  // 문서 ID 포함 (선택사항)
                    name: doc.data().name // 문서 데이터 포함
                }));

                // 최종 포트폴리오 데이터 설정
                setUserPortfolio({
                    positions: positionsData,
                    archives: archiveData,
                    activities: activitiesData,
                    contacts: contactsData,
                    members: membersData
                });                
            } catch (error) {
                console.error("Error fetching collections:", error);
                setOpenPopup(true);
                setPopupTitle("정보 조회 중 오류가 발생했습니다.");
                setPopupButtonText("");
                setPopupFunction("");
            } finally {
                setIsLoading(false);
            }
        }
    }, [userID, musicardID]);      

    // 🔹 정보 조회 전 로그인 세션 확인
    useEffect(() => {
        if (userLoading) return;
            
        if (user?.userID) {
            setUserID(user.userID);
            setIsLoading(true);
            fetchPortfolio();
        } else {
            navigate('/login');
        }
    }, [fetchPortfolio, navigate, user?.userID, userLoading, musicardID]);

    // 🔹 멤버 선택
    const selectMember  = async (memberID) => {
        if (memberID === '') {
            // 1. 유저 기본 정보 (users 컬렉션)
            const userRef = doc(db, "users", userID);
            const userSnap = await getDoc(userRef);
            if (userSnap.exists()) {
                setUserInfo(userSnap.data());
            }

            // 2. 뮤지카드 기본 정보 (musicians 컬렉션)
            const musicardRef = doc(db, "musicians", musicardID);
            const musicardSnap = await getDoc(musicardRef);
            if (musicardSnap.exists()) {
                const musicardData = musicardSnap.data();
    
                // 소유자 검증: 현재 유저가 뮤지카드 소유자가 아니면 오류 처리
                if (musicardData.ownerId !== userID) {
                    setOpenPopup(true);
                    setPopupTitle("해당 뮤지카드의 소유자가 아닙니다.");
                    setPopupButtonText("");
                    setPopupFunction("");
                    setIsLoading(false);
                    return;
                }
                setMusicardInfo(musicardData);
            } else {
                throw new Error("뮤지카드 정보를 찾을 수 없습니다.");
            }

            // 3. 스타일 정보 (스트리밍 & SNS & QR 코드) - musicians/{musicardID}/style/main
            const styleRef = doc(db, "musicians", musicardID, "style", "main");
            const styleSnap = await getDoc(styleRef);
            if (styleSnap.exists()) {
                const styleData = styleSnap.data();
                let newLinks = [];
                // 스트리밍 링크
                if (styleData.musicLinks) {
                    Object.entries(styleData.musicLinks).forEach(([key, value]) => {
                        const newKey = key.charAt(0).toUpperCase() + key.slice(1);
                        if (value.trim() !== "") {
                            newLinks.push({ newKey, value });
                        }
                    });
                }
                // SNS 링크
                if (styleData.sns) {
                    Object.entries(styleData.sns).forEach(([key, value]) => {
                        const newKey = key.charAt(0).toUpperCase() + key.slice(1);
                        if (value.trim() !== "") {
                            newLinks.push({ newKey, value });
                        }
                    });
                }
                if (styleData.qrimg) {
                    setUserQR(styleData.qrimg);
                }
                setUserLinks(newLinks);
            }
    
            // 4. 포지션 & 스킬 (musicians/{musicardID}/positions)
            const positionsSnap = await getDocs(collection(db, "musicians", musicardID, "positions"));
            const positionsData = [];
            for (const posDoc of positionsSnap.docs) {
                // 각 포지션의 스킬 불러오기
                const skillsSnap = await getDocs(collection(db, "musicians", musicardID, "positions", posDoc.id, "skills"));
                let skills = skillsSnap.docs.map(skillDoc => {
                    const s = skillDoc.data();
                    return { name: s.name, level: s.level };
                });
                // 알파벳순 정렬
                skills.sort((a, b) => a.localeCompare(b));
                positionsData.push({ id: posDoc.id, skills });
            }
            // (원하는 순서대로 정렬 – 예시: creator, player, engineer)
            const order = ["creator", "player", "engineer"];
            positionsData.sort((a, b) => order.indexOf(a.id) - order.indexOf(b.id));
        } else {
            const membersSnap = await getDoc(doc(db, "musicians", musicardID, "members", memberID));
            if (membersSnap.exists()) {
                const getMember = membersSnap.data();
                // 유저 정보 초기화
                setUserInfo(prev => ({
                    ...prev,
                    email: '',
                    name: '',
                }));
    
                // 뮤지카드 정보 초기화
                setMusicardInfo(prev => ({
                    ...prev,  // 기존 데이터 유지
                    name: getMember.name,  // 업데이트
                    profileImage: getMember.image // 업데이트
                }));
                
                // 포지션 초기화
                const positionsData = [];
                const skillData = [{ name: getMember.position }];
                positionsData.push({ id: 'Group/Band', skills: skillData });
                setUserPortfolio((prev) => ({
                    ...prev,
                    positions: positionsData
                }));
    
                // 스트리밍 & SNS 초가화
                setUserLinks(null);
                let newLinks = [];
                Object.entries(getMember.sns).forEach(([key, value]) => {
                    const newKey = key.charAt(0).toUpperCase() + key.slice(1);
                    if (value.trim() !== "") {
                        newLinks.push({ newKey, value });
                    }
                });
                setUserLinks(newLinks);
            }
        }
    }

    // 🔹 PDF 다운로드
    const downloadPDF   = async () => {
        const date      = new Date();
        const reDate    = date.toISOString();
        const getDate   = reDate.split('T')[0];
        const hiddenArea= document.getElementById('hiddenArea');
    
        hiddenArea.style.display = 'block';
        setDownloadLoading(true);
    
        const option = {
            margin: 10,
            filename: `${getDate} ${userInfo.name} 포트폴리오.pdf`,
            image: { type: 'jpeg', quality: 0.98 },
            html2canvas: { scale: 2, useCORS: true },
            jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
        };
    
        try {
            const worker = html2pdf().from(hiddenArea).set(option).toPdf();
    
            await worker.get('pdf').then((pdf) => {
                const totalPages = pdf.internal.getNumberOfPages();
    
                pdf.setPage(totalPages);
                pdf.setFontSize(12);
                pdf.setTextColor(4, 2, 6);
    
                const footerText = "Generated by ";
                const linkText = "musizic.com";
                const pageWidth = pdf.internal.pageSize.getWidth();
                const pageHeight = pdf.internal.pageSize.getHeight();
    
                // Footer
                const fullText = `${footerText}${linkText}`;
                const linkX = pageWidth / 2;
                const linkY = pageHeight - 10;

                pdf.textWithLink(fullText, linkX, linkY, {
                    url: 'https://musizic.com',
                    align: 'center'
                });
            });
    
            // PDF 저장
            await worker.save();
    
        } catch (error) {
            console.error("PDF 생성 오류:", error);
        } finally {
            hiddenArea.style.display = 'none';
            setDownloadLoading(false);
        }
    };

    // 🔹 링크 공유하기
    const previewPDF = async () => {
        // 밀리초 단위의 타임스탬프 생성 (파일명에 사용할 수 있는 안전한 값)
        const timestamp = Date.now();
        const hiddenArea = document.getElementById('hiddenArea');
      
        // PDF 생성을 위해 hiddenArea 표시
        hiddenArea.style.display = 'block';
        setViewLoading(true);
      
        try {
          const storage = getStorage();
          // 1. 이전에 생성된 PDF 파일 삭제
          const listRef = ref(storage, `/users/${userID}/`);
          const listResult = await listAll(listRef);
          const deletePromises = listResult.items
            .filter(itemRef => 
              itemRef.name.startsWith(`${musicardID}_portfolio_`) && itemRef.name.endsWith('.pdf')
            )
            .map(itemRef => deleteObject(itemRef));
          await Promise.all(deletePromises);
          console.log("이전 PDF 파일 삭제 완료");
      
          // 2. html2pdf 옵션 설정
          const opt = {
            margin: 10,
            filename: `${timestamp} ${userInfo.name} 포트폴리오.pdf`,
            image: { type: 'jpeg', quality: 0.98 },
            html2canvas: { scale: 2, useCORS: true },
            jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
          };
      
          // 3. PDF Blob 생성
          const pdfBlob = await html2pdf()
            .set(opt)
            .from(hiddenArea)
            .toPdf()
            .get('pdf')
            .then((pdf) => {
                const totalPages = pdf.internal.getNumberOfPages();

                pdf.setPage(totalPages);
                pdf.setFontSize(12);
                pdf.setTextColor(4, 2, 6);

                const footerText = "Generated by ";
                const linkText = "musizic.com";
                const pageWidth = pdf.internal.pageSize.getWidth();
                const pageHeight = pdf.internal.pageSize.getHeight();

                const fullText = `${footerText}${linkText}`;
                const linkX = pageWidth / 2;
                const linkY = pageHeight - 10;

                // 링크를 적용한 텍스트 출력
                pdf.textWithLink(fullText, linkX, linkY, {
                    url: 'https://musizic.com',
                    align: 'center'
                });
            })
            .output('blob');
      
          // 4. Firebase Storage 파일 경로: /users/[UID]/[뮤지카드ID]_portfolio_[timestamp].pdf
          const pdfStorageRef = ref(storage, `/users/${userID}/${musicardID}_portfolio_${timestamp}.pdf`);
      
          // 5. PDF Blob 업로드
          await uploadBytes(pdfStorageRef, pdfBlob);
      
          // 6. 업로드 후 다운로드 URL 가져오기 (필요시)
          const downloadURL = await getDownloadURL(pdfStorageRef);
          console.log("PDF 저장 및 업로드 완료:", downloadURL);
      
         // 7. PDF 뷰어 페이지의 URL 생성 및 공유용 URL로 저장
          const viewerUrl = `${window.location.origin}/pdf-viewer?id=${userID}-${musicardID}-${timestamp}`;
          setSharedUrl(viewerUrl);
          setShowShare(true);
        } catch (error) {
          console.error("PDF 미리보기 업로드 실패:", error);
        } finally {
          hiddenArea.style.display = 'none';
          setViewLoading(false);
        }
    };
      

    // 채널 정보를 파싱하는 함수: "[YouTube] 카미트루" -> 아이콘 + "카미트루"
    const renderChannel = (channel) => {
        if (!channel) return '';
        const regex = /^\[(.*?)\]\s*(.*)$/;
        const match = channel.match(regex);
        if (match) {
        const type = match[1]; // 예: YouTube, Instagram, 기타
        const remainder = match[2];
        // YouTube와 Instagram은 아이콘 파일명이 소문자로 동일함.
        let iconFile = "";
        if (type === "YouTube" || type === "Instagram") {
            iconFile = `${type.toLowerCase()}-icon_1.png`;
        } else if (type === "기타") {
            iconFile = "etc-icon_1.png";
        }
        if (iconFile) {
            return (
            <span style={{ wordBreak: 'break-all' }}>
                <img src={`/assets/icons/${iconFile}`} alt={type} style={{ width: '20px', aspectRatio: '1', marginRight: '4px' }} />
                {remainder}
            </span>
            );
        }
        }
        return channel;
    };

    const formatDate = (date) => {
        const year = date.getFullYear();
        const month = ('0' + (date.getMonth() + 1)).slice(-2); // 월을 0패딩 처리
        const day = ('0' + date.getDate()).slice(-2); // 일을 0패딩 처리
        return `${year}-${month}-${day}`;
    };

  return (
    <>
        <SEO title='포트폴리오' />
        <div className={styleClasses.myPageMobile}>
            <div className={ styleClasses.inner }>
                <div className={ styleClasses.title }>
                    <h1>My Portfolio</h1>
                    <button className={ styleClasses.menuIcon }>
                        <div className="commonIcon mobile">
                            <i className={`${ openMenu ? 'upWhite' : 'downWhite' } w24`}></i>
                        </div>
                    </button>
                </div>
                <div className={ styleClasses.editContent }>
                    {/* 왼쪽 메뉴 */}
                    <div className={`${ styleClasses.leftContent } ${ openMenu ? styleClasses.open : '' }`}>
                        <MyPageMenu currentPage='my-page' />
                    </div>
                    {/* 포트폴리오 */}
                    <div className={ styleClasses.rightContent }>
                        <div className={ styleClasses.portfolioPage }>
                        {
                            isLoading
                            ?
                            (
                                <Loading />
                            )
                            :
                            (
                            <>
                                <div className={ styleClasses.inputWithButtons }>
                                    { musicardInfo?.positions?.includes('Group/Band') && (
                                    <div className="commonForm">
                                        <div className="formRow">
                                            <div className="labelBox">
                                                <label htmlFor="selectMember">멤버 선택</label>
                                            </div>
                                            <div className="fieldBox">
                                                <select id="selectMember" value={ memberID } onChange={ (e) => { setMemberID(e.target.value); selectMember(e.target.value) } }>
                                                    <option value="">Group / Band</option>
                                                    {
                                                        userPortfolio?.members?.length > 0
                                                        &&
                                                        userPortfolio.members.map((member) => (
                                                            <option value={ member.id }>{ member.name }</option>
                                                        ))
                                                    }
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    )}
                                    <div className={ styleClasses.topButtons }>
                                        <div className={`commonButton fullWidth ${ styleClasses.lastButton }`}>
                                            <Link to='/my-page' className="secondary">뒤로가기</Link>
                                        </div>
                                        <div className={`commonButton fullWidth ${ styleClasses.lastButton }`}>
                                            <button className="black" onClick={ downloadPDF } disabled={ downloadLoading }>
                                                다운로드
                                                <div className={`buttonLoading ${ downloadLoading ? 'active' : undefined }`}>
                                                    <div></div>
                                                    <div></div>
                                                    <div></div>
                                                </div>
                                            </button>
                                        </div>
                                        <div className={`commonButton fullWidth ${ styleClasses.lastButton }`}>
                                            <button className="black" onClick={ previewPDF } disabled={ viewLoading }>
                                                링크 공유하기
                                                <div className={`buttonLoading ${ viewLoading ? 'active' : undefined }`}>
                                                    <div></div>
                                                    <div></div>
                                                    <div></div>
                                                </div>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div className={ styleClasses.portfolioSection }>
                                    <div className={ styleClasses.basicInfo }>
                                        <div className={ styleClasses.imageBox } style={{ backgroundImage: `url("${ musicardInfo?.profileImage || '/assets/images/Background Test 1.png' }")` }}>
                                        {
                                            userQR
                                            &&
                                            <div className={ styleClasses.qrCode }>
                                                <img src={ userQR } alt="뮤지카드 QR 코드" />
                                            </div>
                                        }
                                        </div>
                                        <div className={ styleClasses.textBox }>
                                            {
                                                musicardInfo?.name && 
                                                <h1>{ musicardInfo?.name }</h1>
                                            }
                                            {
                                                userInfo?.name &&
                                                <p>{ userInfo?.name }</p>
                                            }
                                            {
                                                musicardInfo?.genres &&                                        
                                                <p>{ musicardInfo.genres.join(', ') }</p>
                                            }
                                            {
                                                musicardInfo?.positions &&                                        
                                                <p>{ musicardInfo.positions.join(', ') }</p>
                                            }
                                            {
                                                userInfo?.email &&
                                                <p>{ userInfo?.email }</p>
                                            }
                                            <div className="commonForm">
                                                <div className="formRow">
                                                    <div className="fieldBox">
                                                        <input type="text" value={ userMobile } placeholder="휴대폰 번호" onChange={ (e) => setUserMobile(e.target.value) } />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="commonForm">
                                                <div className="formRow">
                                                    <div className="fieldBox">
                                                        <input type="text" value={ userAddress } placeholder="주소" onChange={ (e) => setUserAddress(e.target.value) } />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {/* 포지션 & 스킬 */}
                                    {
                                        userPortfolio?.positions.length > 0
                                        &&
                                        (
                                            <div className={styleClasses.eachInfo}>
                                                <div className={styleClasses.inner}>
                                                    <h1>포지션 &amp; 스킬</h1>
                                                    <table>
                                                    <tbody>
                                                        {userPortfolio.positions.map((position) => (
                                                        <tr key={`position${ position.id }`}>
                                                            <td>
                                                                {position.id.charAt(0).toUpperCase() + position.id.slice(1)}
                                                            </td>
                                                            <td>
                                                                {position.skills.map((skill, idx) => (
                                                                    <div key={`skill${ idx }`} className={styleClasses.skillItem}>
                                                                        <span className={ styleClasses.skillName }>{skill.name}</span>
                                                                        {
                                                                            skill.level
                                                                            &&
                                                                            (
                                                                                <>
                                                                                    <div className={styleClasses.skillLevelBar}>
                                                                                        <div
                                                                                        className={styleClasses.skillBarFill}
                                                                                        style={{
                                                                                            width: `${levelToPercentage[skill.level]}%`,
                                                                                        }}
                                                                                        ></div>
                                                                                    </div>
                                                                                    <span className={styleClasses.skillLevel}>
                                                                                        {skill.level} (
                                                                                        {levelToPercentage[skill.level]
                                                                                        ? levelToPercentage[skill.level]
                                                                                        : 0}
                                                                                        %)
                                                                                    </span>
                                                                                </>
                                                                            )
                                                                        }
                                                                    </div>
                                                                ))}
                                                            </td>
                                                        </tr>
                                                        ))}
                                                    </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        )
                                    }
                                    {/* 경력사항 */}
                                    {
                                        userPortfolio?.archives.length > 0
                                        &&
                                        (
                                            <div className={ styleClasses.eachInfo }>
                                                <div className={ styleClasses.inner }>
                                                    <h1>참여 음반</h1>
                                                    <table>
                                                        <tbody>
                                                        {
                                                            userPortfolio.archives.map((archive, index) => (
                                                                <tr key={`archive${ archive.id }-${ index }`}>
                                                                    <td>
                                                                        <div className={ styleClasses.column }>
                                                                            { archive.year ? formatDate(archive.year) : '' }
                                                                        </div>
                                                                        <div className={ styleClasses.column }>
                                                                            { archive.albumType }
                                                                        </div>
                                                                    </td>
                                                                    <td>
                                                                        {
                                                                            archive.albumTitle
                                                                            ?
                                                                            <div className={ styleClasses.column }>
                                                                            {
                                                                                archive.trackLink
                                                                                ?
                                                                                <Link to={ archive.trackLink } target="_blank"> { archive.albumTitle} </Link>
                                                                                :
                                                                                archive.albumTitle
                                                                            }
                                                                            </div>
                                                                            :
                                                                            null
                                                                        }
                                                                        {
                                                                            archive.trackTitle
                                                                            ?
                                                                            <div className={ styleClasses.column }>
                                                                            {
                                                                                archive.trackLink
                                                                                ?
                                                                                <Link to={ archive.trackLink } target="_blank">
                                                                                {
                                                                                    <><span className={ styleClasses.trackTitle }>타이틀</span>{ archive.trackTitle }</>
                                                                                
                                                                                }
                                                                                </Link>
                                                                                :
                                                                                <><span className={ styleClasses.trackTitle }>타이틀</span>{ archive.trackTitle }</>
                                                                            }
                                                                            </div>
                                                                            :
                                                                            null
                                                                        }
                                                                        {
                                                                            archive.artist
                                                                            ?
                                                                            <div className={ styleClasses.column }>
                                                                                { archive.artist }
                                                                            </div>
                                                                            :
                                                                            null
                                                                        }
                                                                    </td>
                                                                </tr>
                                                            ))    
                                                        }
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        )
                                    }
                                    {/* 활동사항 */}
                                    {
                                        userPortfolio?.activities.length > 0
                                        &&
                                        (
                                            <div className={ styleClasses.eachInfo }>
                                                <div className={ styleClasses.inner }>
                                                    <h1>음악 활동</h1>
                                                    <table>
                                                        <tbody>
                                                        {
                                                            userPortfolio.activities.map((activity) => (
                                                                <tr key={`activity${ activity.id }`}>
                                                                    <td>{ activity.date }</td>
                                                                    <td>
                                                                        <div className={ styleClasses.column }>
                                                                        {
                                                                            activity.link
                                                                            ?
                                                                            <Link to={ activity.link ?? '' } target="_blank">{ activity.title }</Link>
                                                                            :
                                                                            activity.title
                                                                        }
                                                                        </div>
                                                                        <div className={ styleClasses.column }>
                                                                        { renderChannel(activity.channel) }
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                            ))
                                                        }
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        )
                                    }
                                    {/* 스트리밍 & SNS  */}
                                    {
                                        userLinks
                                        &&
                                        (                                            
                                        <div className={ styleClasses.eachInfo }>
                                            <div className={ styleClasses.inner }>
                                                <h1>스트리밍 & SNS</h1>
                                                <table>
                                                    <tbody>
                                                    {
                                                        userLinks.map((link) => (
                                                            <tr key={`link${ link.newKey }`}>
                                                                <td>{ link.newKey }</td>
                                                                <td><Link to={ link.value } target="_blank">{ link.value }</Link></td>
                                                            </tr>
                                                        ))
                                                    }
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                        )
                                    }
                                </div>
                                <div id="hiddenArea" className={ styleClasses.portfolioSection } style={{ width: '720px', display: 'none' }}>
                                    <div className={ styleClasses.basicInfo } style={{ width: '100%', display: 'flex', alignItems: 'flex-start', justifyContent: 'flex-start'}}>
                                        <div className={ styleClasses.imageBox }
                                            style={{
                                                position: 'relative',
                                                flex: '200px 0 0',
                                                width: '200px',
                                                aspectRatio: '1',
                                                paddingRight: '32px',
                                                backgroundColor: '#F9F7FC',
                                                borderBottomRightRadius: '36px',
                                                backgroundImage: `url("${ musicardInfo?.profileImage || '/assets/images/Background Test 1.png' }")`,
                                                backgroundSize: 'cover',
                                                backgroundPosition: 'center'
                                            }}>
                                            {/* <img src={ musicardInfo?.profileImage } alt="프로필 이미지" style={{ width: '100%', aspectRatio: '1', objectFit: 'cover', backgroundColor: '#F9F7FC', borderBottomRightRadius: '36px' }} /> */}
                                            {
                                                userQR
                                                &&
                                                <div className={ styleClasses.qrCode } style={{ position: 'absolute', right: '8px', bottom: '8px', width: '64px', height: '64px', borderRadius: '50%', backgroundColor: '#FFFFFF', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                    <img src={ userQR } alt="뮤지카드 QR 코드" style={{ width: '48px', height: '48px', borderRadius: '4px' }} />
                                                </div>
                                            }
                                        </div>
                                        <div className={ styleClasses.textBox } style={{ flex: 'calc(100% - 200px) 0 0', width: 'width: calc(100% - 200px)', paddingLeft: '32px' }}>
                                            {
                                                musicardInfo?.name && 
                                                <h1 style={{ fontSize: '32px', lineHeight: '40px', paddingBottom: '16px' }}>{ musicardInfo?.name }</h1>
                                            }
                                            <p style={{ fontSize: '14px', lineHeight: '20px', paddingLeft: '8px', marginBottom: '8px' }}>{ userInfo?.name }</p>
                                            {
                                                musicardInfo?.genres &&                                        
                                                <p style={{ fontSize: '14px', lineHeight: '20px', paddingLeft: '8px', marginBottom: '8px' }}>{ musicardInfo.genres.join(', ') }</p>
                                            }
                                            {
                                                musicardInfo?.positions &&                                        
                                                <p style={{ fontSize: '14px', lineHeight: '20px', paddingLeft: '8px', marginBottom: '8px' }}>{ musicardInfo.positions.join(', ') }</p>
                                            }
                                            <p style={{ fontSize: '14px', lineHeight: '20px', paddingLeft: '8px', marginBottom: '8px' }}>{ userInfo?.email }</p>
                                            <p style={ userMobile === '' ? { display: 'none' } : { fontSize: '14px', lineHeight: '20px', paddingLeft: '8px', marginBottom: '8px' } }>{ userMobile }</p>
                                            <p style={ userAddress === '' ? { display: 'none' } : { fontSize: '14px', lineHeight: '20px', paddingLeft: '8px', marginBottom: '8px' } }>{ userAddress }</p>
                                        </div>
                                    </div>
                                    {/* 포지션 & 스킬 */}
                                    {
                                        userPortfolio?.positions.length > 0
                                        &&
                                        (
                                            <div className={ styleClasses.eachInfo } style={{ marginTop: '32px' }}>
                                                <div className={ styleClasses.inner }>
                                                    <h1 style={{ fontSize: '16px', lineHeight: '24px', paddingBottom: '8px' }}>포지션 & 스킬</h1>
                                                    <table style={{ width: '100%'}}>
                                                        <tbody>
                                                        {
                                                            userPortfolio.positions.map((position, index) => (
                                                                <tr key={`duplicatePosition${ index }-${ position.id }`} style={{ borderBottom: '0.5px solid #A8A8A8', pageBreakInside: 'avoid' }}>
                                                                    <td style={{ width: '120px', padding: '8px 16px', fontSize: '14px', verticalAlign: 'baseline', pageBreakInside: 'avoid' }}>{ position.id.charAt(0).toUpperCase() + position.id.slice(1) }</td>
                                                                    <td style={{ width: 'calc(100% - 120px)', padding: '0', fontSize: '14px', verticalAlign: 'baseline', pageBreakInside: 'avoid' }}>
                                                                    {position.skills.map((skill, idx) => (
                                                                        <div key={`duplicateSkill${ idx }`} className={styleClasses.skillItem} style={{ display: 'flex', alignItems: 'center', gap: '15px', padding: '8px 0' }}>
                                                                            <span style={{ width: '20%' }}>{skill.name}</span>
                                                                            {
                                                                                skill.level
                                                                                &&
                                                                                (
                                                                                    <>
                                                                                        <div className={styleClasses.skillLevelBar} style={{ backgroundColor: '#EEE8F7', height: '8px', borderRadius: '4px', overflow: 'hidden', width: '100%', maxWidth: '200px' }}>
                                                                                            <div
                                                                                            className={styleClasses.skillBarFill}
                                                                                            style={{
                                                                                                width: `${levelToPercentage[skill.level]}%`,
                                                                                                height: '100px',
                                                                                                backgroundColor: '#007bff',
                                                                                                backgroundImage: 'linear-gradient(45deg, #007bff, #A862FF)',
                                                                                                borderTopRightRadius: '4px',
                                                                                                borderBottomRightRadius: '4px',
                                                                                            }}
                                                                                            ></div>
                                                                                        </div>
                                                                                        <span className={styleClasses.skillLevel} style={{ color: '#323134', fontSize: '12px', lineHeight: '20px', fontWeight: '600' }}>
                                                                                            {skill.level} (
                                                                                            {levelToPercentage[skill.level]
                                                                                            ? levelToPercentage[skill.level]
                                                                                            : 0}
                                                                                            %)
                                                                                        </span>
                                                                                    </>
                                                                                )
                                                                            }
                                                                        </div>
                                                                    ))}
                                                                    </td>
                                                                </tr>
                                                            ))
                                                        }
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>

                                        )
                                    }
                                    {/* 경력사항 */}
                                    {
                                        userPortfolio?.archives.length > 0
                                        &&
                                        (
                                            <div className={ styleClasses.eachInfo } style={{ marginTop: '32px' }}>
                                                <div className={ styleClasses.inner } style={{ color: '#040206', textDecoration: 'unset', fontFamily: 'Godo' }} >
                                                    <h1 style={{ fontSize: '16px', lineHeight: '24px', paddingBottom: '8px' }}>참여 음반</h1>
                                                    <table style={{ width: '100%'}}>
                                                        <tbody>
                                                        {
                                                            userPortfolio.archives.map((archive, index) => (
                                                                <tr key={`duplicateArchive${ index }-${ archive.id }`} className={ styleClasses.archiveColumn } style={{ borderBottom: '0.5px solid #A8A8A8', pageBreakInside: 'avoid' }}>
                                                                    <td style={{ width: '120px', padding: '8px 16px', fontSize: '14px', verticalAlign: 'baseline', pageBreakInside: 'avoid' }}>{ archive.year ? formatDate(archive.year) : '' }</td>
                                                                    <td style={{ width: '70px',padding: '8px 0', fontSize: '14px', verticalAlign: 'baseline', pageBreakInside: 'avoid' }}>{ archive.albumType }</td>
                                                                    <td style={{ width: 'calc(100% - 70px - 120px - 240px)', padding: '8px 0', fontSize: '14px', verticalAlign: 'baseline', pageBreakInside: 'avoid' }}>
                                                                        {
                                                                            archive.trackLink
                                                                            ?
                                                                            <Link to={ archive.trackLink } target="_blank" style={{ color: '#040206', textDecoration: 'unset', fontFamily: 'Godo' }} >
                                                                                {
                                                                                    archive.albumTitle
                                                                                    &&
                                                                                    <span className={ styleClasses.albumTitle } style={{ marginRight: '16px' }}>{ archive.albumTitle }</span>
                                                                                }
                                                                                { 
                                                                                    archive.trackTitle
                                                                                    &&
                                                                                    <>
                                                                                        <span className={ styleClasses.trackTitle } style={{ display: 'inline-block', color: '#040206', fontSize: '12px', lineHeight: '16px', backgroundColor: '#D9D9D9', borderRadius: '4px', padding: '2px 8px', marginRight: '8px'  }}>타이틀</span>{ archive.trackTitle }
                                                                                    </>
                                                                                }
                                                                                </Link>
                                                                            :
                                                                            <><span className={ styleClasses.albumTitle }>{ archive.albumTitle }</span> { archive.trackTitle && <><span className={ styleClasses.trackTitle }>타이틀</span>{ archive.trackTitle }</> }</>
                                                                        }
                                                                    </td>
                                                                    <td style={{ width: '240px', fontSize: '12px', verticalAlign: 'center', padding: '8px 8px' }}>{ archive.artist }</td>
                                                                </tr>
                                                            ))    
                                                        }
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        )
                                    }
                                    {/* 활동사항 */}
                                    {
                                        userPortfolio?.activities.length > 0
                                        &&
                                        (
                                            <div className={ styleClasses.eachInfo } style={{ marginTop: '32px' }}>
                                                <div className={ styleClasses.inner } style={{ color: '#040206', textDecoration: 'unset', fontFamily: 'Godo' }} >
                                                    <h1 style={{ fontSize: '16px', lineHeight: '24px', paddingBottom: '8px', pageBreakInside: 'avoid' }}>음악 활동</h1>
                                                    <table style={{ width: '100%'}}>
                                                        <tbody>
                                                        {
                                                            userPortfolio.activities.map((activity, index) => (
                                                                <tr key={`duplicateActivity${ index }-${ activity.id }`} className={ styleClasses.activityColumn } style={{ borderBottom: '0.5px solid #A8A8A8', pageBreakInside: 'avoid' }}>
                                                                    <td style={{ width: '120px', padding: '8px 16px', fontSize: '14px', verticalAlign: 'baseline', pageBreakInside: 'avoid' }}>{ activity.date }</td>
                                                                    <td style={{ width: '450px', padding: '8px 0', fontSize: '14px', verticalAlign: 'baseline', pageBreakInside: 'avoid' }}>{ activity.link ? <Link to={ activity.link ?? '' } target="_blank" style={{ color: '#040206', textDecoration: 'unset', fontFamily: 'Godo' }} >{ activity.title }</Link> : activity.title }</td>
                                                                    <td style={{ width: 'calc(100% - 450px - 120px)', padding: '8px 0', fontSize: '12px', verticalAlign: 'baseline', pageBreakInside: 'avoid' }}>{ renderChannel(activity.channel) }</td>
                                                                </tr>
                                                            ))
                                                        }
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        )
                                    }
                                    {/* 스트리밍 & SNS  */}
                                    {
                                        userLinks
                                        &&
                                        (                                            
                                        <div className={ styleClasses.eachInfo } style={{ marginTop: '32px' }}>
                                            <div className={ styleClasses.inner } style={{ color: '#040206', textDecoration: 'unset', fontFamily: 'Godo' }} >
                                                <h1 style={{ fontSize: '16px', lineHeight: '24px', paddingBottom: '8px' }}>스트리밍 & SNS</h1>
                                                <table style={{ width: '100%'}}>
                                                    <tbody>
                                                    {
                                                        userLinks.map((link, index) => (
                                                            <tr key={`duplicateLink${ index }-${ link.newKey }`} style={{ borderBottom: '0.5px solid #A8A8A8', pageBreakInside: 'avoid' }}>
                                                                <td style={{ width: '136px', padding: '8px 16px', fontSize: '14px', verticalAlign: 'baseline', pageBreakInside: 'avoid' }}>{ link.newKey }</td>
                                                                <td style={{ width: 'calc(100% - 136px)', padding: '8px 0', fontSize: '14px', verticalAlign: 'baseline', pageBreakInside: 'avoid' }}><Link to={ link.value } target="_blank" style={{ color: '#040206', textDecoration: 'unset', fontFamily: 'Godo' }} >{ link.value }</Link></td>
                                                            </tr>
                                                        ))
                                                    }
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                        )
                                    }
                                </div>
                            </>
                            )
                        }
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Popup open={ openPopup } setOpenPopup={ setOpenPopup } title={ popupTitle } text='' buttonText={ popupButtonText } buttonFunction={ popupFunction } />
        {
            showShare && (
                <MusicardPopup
                id={musicardID}  // 필요에 따라 전달 (예: 뮤지카드 id)
                setModalOpen={setShowShare}
                closeStyle="share"
                element={
                  <Share
                    url={sharedUrl}  // previewPDF 함수에서 업로드 후 설정한 공유용 URL
                    musician={ musicardInfo }  // 필요에 따라 실제 데이터를 전달
                    //image={ userQR }  // 필요 시 추가
                  />
                }
              />
            )
        }
    </>
  );
}

export default Portfolio;
